export default {
  ResizableField: {
    mounted() {
      this.initialize();
    },

    updated() {
      this.initialize();
    },

    initialize() {
      if (this.resizeInProgress) {
        this.stopResize();
      }
      this.newWidth = null;
      this.newHeight = null;
      this.resizeInProgress = false;
      this.resizableFieldEvent = this.el.dataset.resizableFieldEvent;
      this.resizableFieldTarget = this.el.dataset.resizableFieldTarget;
      this.resizableWidthParam = this.el.dataset.resizableWidthParameter;
      this.resizableHeightParam = this.el.dataset.resizableHeightParameter;
      this.resizableElements = Array.from(this.el.querySelectorAll('[data-resizable-for]'));

      const handleIndicator = document.createElement('div');
      handleIndicator.className = 'pointer-events-none flex items-center justify-center text-base-500 p-1';
      // Use arrows-pointing-out icon for resize handle
      const icon = document.createElement('span');
      icon.className = 'hero-arrows-pointing-out w-5 h-5';
      handleIndicator.appendChild(icon);

      this.resizeHandleTemplate = document.createElement('div');
      this.resizeHandleTemplate.className =
        'resizable-handle no-drag absolute right-0 bottom-0 ' +
        'cursor-se-resize flex items-center justify-center ' +
        'opacity-0 group-hover:opacity-100 transition-opacity duration-200 ' +
        'bg-white/90 backdrop-blur-sm rounded-tl';
      this.resizeHandleTemplate.style.userSelect = 'none';

      this.resizeHandleTemplate.appendChild(handleIndicator);
      this.addResizingEventListeners();
    },

    addResizingEventListeners() {
      for (let elem of this.resizableElements) {
        if (!elem.style.position) {
          elem.style.position = 'relative';
        }
        // Ensure element has group class for group-hover to work
        elem.classList.add('group');
        const handleClone = this.resizeHandleTemplate.cloneNode(true);
        elem.appendChild(handleClone);

        handleClone.addEventListener('pointerdown', e => {
          e.preventDefault();
          e.stopPropagation();
          this.startResize(elem, e);
        });

        handleClone.addEventListener('click', e => {
          e.stopPropagation();
        });
      }
    },

    startResize(resizableElement, pointerDownEvent) {
      this.resizeInProgress = true;
      pointerDownEvent.target.setPointerCapture(pointerDownEvent.pointerId);

      const startX = pointerDownEvent.pageX;
      const startY = pointerDownEvent.pageY;
      const startWidth = resizableElement.offsetWidth;
      const startHeight = resizableElement.offsetHeight;

      let handleResizeDrag = this.handleResizeDrag.bind({
        startX,
        startY,
        startWidth,
        startHeight,
        resizableElement,
        self: this,
      });

      document.addEventListener('pointermove', handleResizeDrag);

      let handleResizeDragRelease = this.handleResizeDragRelease.bind({
        resizableElement,
        handleResizeDrag,
        self: this,
      });

      document.addEventListener('pointerup', handleResizeDragRelease, { once: true });
    },

    handleResizeDrag(event) {
      if (!this.self.resizeInProgress) return;
      const deltaX = event.pageX - this.startX;
      const deltaY = event.pageY - this.startY;
      const newWidth = Math.round(Math.max(50, this.startWidth + deltaX));
      const newHeight = Math.round(Math.max(50, this.startHeight + deltaY));
      // Update max-width and height
      if (this.self.resizableWidthParam == 'width') {
        this.resizableElement.style.width = newWidth + 'px';
      } else if (this.self.resizableWidthParam == 'maxWidth') {
        this.resizableElement.style.maxWidth = newWidth + 'px';
      }

      if (this.self.resizableHeightParam == 'height') {
        this.resizableElement.style.height = newHeight + 'px';
      } else if (this.self.resizableHeightParam == 'maxHeight') {
        this.resizableElement.style.maxHeight = newHeight + 'px';
      }

      this.self.newWidth = newWidth;
      this.self.newHeight = newHeight;
    },

    handleResizeDragRelease(event) {
      event.target.releasePointerCapture(event.pointerId);
      this.self.stopResize();
      document.removeEventListener('pointermove', this.handleResizeDrag);
      const slug = this.resizableElement.dataset.resizableFor;
      const width = this.self.newWidth;
      const height = this.self.newHeight ?? this.resizableElement.offsetHeight;
      this.self.updateServer(slug, width, height);
      this.self.newWidth = null;
      this.self.newHeight = null;
    },

    stopResize() {
      this.resizeInProgress = false;
    },

    updateServer(slug, width, height) {
      const payload = { slug, width, height };
      if (this.resizableFieldTarget) {
        this.pushEventTo(this.resizableFieldTarget, this.resizableFieldEvent, payload);
      } else {
        this.pushEvent(this.resizableFieldEvent, payload);
      }
    },
  },
};
